(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 78883:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(28141);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7352:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var _map = {
    "SUPERADMIN": "SUPERADMIN",
    "CUSTOMER": "CUSTOMER",
    "WAITLIST": "WAITLIST",
    "REVIEWER": "REVIEWER"
};
function tToJs(param) {
    return param;
}
function tFromJs(param) {
    return _map[param];
}
var UserRole = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "User.UserRole.t",
    tToJs: tToJs,
    tFromJs: tFromJs
});
var _map$1 = {
    "CANARY": "CANARY"
};
function tToJs$1(param) {
    return param;
}
function tFromJs$1(param) {
    return _map$1[param];
}
var ExtensionBuild = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "User.ExtensionBuild.t",
    tToJs: tToJs$1,
    tFromJs: tFromJs$1
});
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "token",
            Decco.stringToJson(v.token)
        ],
        [
            "userId",
            Decco.stringToJson(v.userId)
        ],
        [
            "email",
            Decco.stringToJson(v.email)
        ],
        [
            "role",
            Curry._1(UserRole.t_encode, v.role)
        ],
        [
            "build",
            Decco.optionToJson(ExtensionBuild.t_encode, v.build)
        ],
        [
            "finishedOnboarding",
            Decco.boolToJson(v.finishedOnboarding)
        ],
        [
            "userFlags",
            Decco.arrayToJson(Decco.stringToJson, v.userFlags)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var token = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "token"), null));
    if (token.TAG === /* Ok */ 0) {
        var userId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "userId"), null));
        if (userId.TAG === /* Ok */ 0) {
            var email = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
            if (email.TAG === /* Ok */ 0) {
                var role = Curry._1(UserRole.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "role"), null));
                if (role.TAG === /* Ok */ 0) {
                    var build = Decco.optionFromJson(ExtensionBuild.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "build"), null));
                    if (build.TAG === /* Ok */ 0) {
                        var finishedOnboarding = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "finishedOnboarding"), null));
                        if (finishedOnboarding.TAG === /* Ok */ 0) {
                            var userFlags = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "userFlags"), null));
                            if (userFlags.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        token: token._0,
                                        userId: userId._0,
                                        email: email._0,
                                        role: role._0,
                                        build: build._0,
                                        finishedOnboarding: finishedOnboarding._0,
                                        userFlags: userFlags._0
                                    }
                                };
                            }
                            var e = userFlags._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".userFlags" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = finishedOnboarding._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".finishedOnboarding" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = build._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".build" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = role._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".role" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = email._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".email" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = userId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".userId" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = token._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".token" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
exports.UserRole = UserRole;
exports.ExtensionBuild = ExtensionBuild;
exports.t_encode = t_encode;
exports.t_decode = t_decode; /* UserRole Not a pure module */ 


/***/ }),

/***/ 28141:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var Fetch = __webpack_require__(84403);
var React = __webpack_require__(67294);
var Js_exn = __webpack_require__(82900);
var Js_dict = __webpack_require__(97076);
var Head = (__webpack_require__(9008)["default"]);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Router = __webpack_require__(11163);
var User$SmartcutsMacros = __webpack_require__(7352);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var StyleCreds$SmartcutsMacros = __webpack_require__(1599);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StylePublic$SmartcutsMacros = __webpack_require__(24782);
var LayoutPublic$SmartcutsMacros = __webpack_require__(64056);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var SignInParams = {};
var SignInResponse = {};
function signIn(email, password) {
    return fetch("/api/login", Fetch.RequestInit.make(/* Post */ 2, {
        "Content-Type": "application/json"
    }, Caml_option.some(JSON.stringify({
        email: email,
        password: password
    })), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function(res) {
        var match = res.status;
        if (match !== 200) {
            return res.text().then(Js_exn.raiseError);
        } else {
            return res.json().then(function(json) {
                return Promise.resolve(json);
            });
        }
    });
}
function Login(Props) {
    var match1 = React.useState(function() {
        return {
            email: "",
            password: "",
            status: /* CredsNotSubmitted */ 0
        };
    });
    var setUserData = match1[1];
    var userData1 = match1[0];
    var router = Router.useRouter();
    var arg1 = Belt_Option.map(Js_dict.get(router.query, "redirect"), function(prim) {
        return decodeURIComponent(prim);
    });
    var redirect = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg1);
    }("/app");
    var handleSubmit = function handleSubmit($$event) {
        $$event.preventDefault();
        Curry._1(setUserData, function(userData) {
            return {
                email: userData.email,
                password: userData.password,
                status: /* SubmittingCreds */ 1
            };
        });
        signIn(userData1.email, userData1.password).then(function(param) {
            var match = OptionUtils$SmartcutsMacros.andThen(User$SmartcutsMacros.ExtensionBuild.tFromJs, param.build);
            var url = match !== undefined ? "https://canary.trysmartcuts.com" + redirect : redirect;
            router.push(url, undefined, undefined);
            return Promise.resolve(undefined);
        }).catch(function(err) {
            console.error(err);
            var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, err);
            var exit = 0;
            if (typeof jsExn === "number") {
                if (jsExn === /* NotFound */ 0) {
                    Curry._1(setUserData, function(userData) {
                        return {
                            email: userData.email,
                            password: userData.password,
                            status: /* LoginError */ {
                                _0: "Not found"
                            }
                        };
                    });
                } else {
                    exit = 1;
                }
            } else {
                switch(jsExn.TAG | 0){
                    case /* JsExn */ 0:
                        var jsExn$1 = jsExn._0;
                        Curry._1(setUserData, function(userData) {
                            var arg = OptionUtils$SmartcutsMacros.map(jsExn$1.message, function(msg) {
                                if (msg === "authentication failed") {
                                    return "Wrong email or password";
                                } else {
                                    return msg;
                                }
                            });
                            return {
                                email: userData.email,
                                password: userData.password,
                                status: /* LoginError */ {
                                    _0: function(param) {
                                        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                    }("An error occurred.")
                                }
                            };
                        });
                        break;
                    case /* InvalidArgument */ 3:
                        var arg2 = jsExn._0;
                        Curry._1(setUserData, function(userData) {
                            return {
                                email: userData.email,
                                password: userData.password,
                                status: /* LoginError */ {
                                    _0: "Invalid arguments: " + arg2
                                }
                            };
                        });
                        break;
                    case /* SysError */ 4:
                        var msg1 = jsExn._0;
                        Curry._1(setUserData, function(userData) {
                            return {
                                email: userData.email,
                                password: userData.password,
                                status: /* LoginError */ {
                                    _0: "System error: " + msg1
                                }
                            };
                        });
                        break;
                    case /* UnknownPromiseError */ 13:
                        exit = 1;
                        break;
                    default:
                        exit = 1;
                }
            }
            if (exit === 1) {
                Curry._1(setUserData, function(userData) {
                    return {
                        email: userData.email,
                        password: userData.password,
                        status: /* LoginError */ {
                            _0: "Unknown error"
                        }
                    };
                });
            }
            return Promise.resolve(undefined);
        });
    };
    var match$1 = userData1.status;
    var match$2 = userData1.status;
    var error = userData1.status;
    return React.createElement(LayoutPublic$SmartcutsMacros.make, {
        onClickCallToAction: function(param) {
            router.push("/", undefined, undefined);
        },
        children: null
    }, React.createElement(Head, {
        children: React.createElement("title", undefined, ReactUtils$SmartcutsMacros.s("Login | Smartcuts"))
    }), React.createElement("div", {
        className: StyleCreds$SmartcutsMacros.creds
    }, React.createElement("form", {
        className: StyleCreds$SmartcutsMacros.form,
        onSubmit: handleSubmit
    }, React.createElement("input", {
        className: StylePublic$SmartcutsMacros.textInput + (" " + Curry._1(Css.style, {
            hd: Css.width(Css.px(282)),
            tl: /* [] */ 0
        })),
        id: "email",
        name: "email",
        placeholder: "Email",
        type: "email",
        value: userData1.email,
        onChange: function($$event) {
            var email = $$event.target.value;
            return Curry._1(setUserData, function(userData) {
                return {
                    email: email,
                    password: userData.password,
                    status: userData.status
                };
            });
        }
    }), React.createElement("input", {
        className: StylePublic$SmartcutsMacros.textInput + (" " + Curry._1(Css.style, {
            hd: Css.width(Css.px(282)),
            tl: /* [] */ 0
        })),
        id: "password",
        name: "password",
        placeholder: "Password",
        type: "password",
        value: userData1.password,
        onChange: function($$event) {
            var password = $$event.target.value;
            return Curry._1(setUserData, function(userData) {
                return {
                    email: userData.email,
                    password: password,
                    status: userData.status
                };
            });
        }
    }), React.createElement("button", {
        className: StylePublic$SmartcutsMacros.button,
        disabled: typeof match$1 === "number" ? match$1 !== 0 : false,
        type: "submit"
    }, typeof match$2 === "number" && match$2 !== 0 ? ReactUtils$SmartcutsMacros.s("Logging in") : ReactUtils$SmartcutsMacros.s("Login")), typeof error === "number" ? React.createElement("p", {
        className: StyleCreds$SmartcutsMacros.error
    }, ReactUtils$SmartcutsMacros.s(" ")) : React.createElement("p", {
        className: StyleCreds$SmartcutsMacros.error
    }, ReactUtils$SmartcutsMacros.s(error._0))), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("Forgot your password? "), React.createElement("a", {
        href: "/forgot_password"
    }, ReactUtils$SmartcutsMacros.s("Reset my password")))));
}
var make = Login;
var $$default = Login;
exports.SignInParams = SignInParams;
exports.SignInResponse = SignInResponse;
exports.signIn = signIn;
exports.make = make;
exports.$$default = $$default;
exports["default"] = $$default;
exports.__esModule = true; /* Css Not a pure module */ 


/***/ }),

/***/ 1599:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var creds = Curry._1(Css.style, {
    hd: Css.maxWidth({
        NAME: "px",
        VAL: 340
    }),
    tl: {
        hd: Css.margin2("zero", "auto"),
        tl: /* [] */ 0
    }
});
var form = Curry._1(Css.style, {
    hd: Css.display("flex"),
    tl: {
        hd: Css.flexDirection("column"),
        tl: /* [] */ 0
    }
});
var label = Curry._1(Css.style, {
    hd: Css.fontWeight({
        NAME: "num",
        VAL: 600
    }),
    tl: /* [] */ 0
});
var input = Curry._1(Css.style, {
    hd: Css.padding({
        NAME: "px",
        VAL: 8
    }),
    tl: {
        hd: Css.margin3({
            NAME: "rem",
            VAL: 0.3
        }, "zero", {
            NAME: "rem",
            VAL: 1.0
        }),
        tl: {
            hd: Css.border({
                NAME: "px",
                VAL: 1
            }, "solid", Css.hex("ccc")),
            tl: {
                hd: Css.borderRadius({
                    NAME: "px",
                    VAL: 4
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var error = Curry._1(Css.style, {
    hd: Css.margin3({
        NAME: "rem",
        VAL: 0.5
    }, "zero", "zero"),
    tl: {
        hd: Css.color(Css.hex("f00")),
        tl: {
            hd: Css.minHeight(Css.px(25)),
            tl: /* [] */ 0
        }
    }
});
exports.creds = creds;
exports.form = form;
exports.label = label;
exports.input = input;
exports.error = error; /* creds Not a pure module */ 


/***/ }),

/***/ 24782:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var button = Curry._1(Css.style, {
    hd: Css.fontFamily({
        NAME: "custom",
        VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
    }),
    tl: {
        hd: Css.fontWeight("bold"),
        tl: {
            hd: Css.color({
                NAME: "hex",
                VAL: "fff"
            }),
            tl: {
                hd: Css.fontSize({
                    NAME: "px",
                    VAL: 17
                }),
                tl: {
                    hd: Css.background({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: {
                        hd: Css.padding({
                            NAME: "px",
                            VAL: 20
                        }),
                        tl: {
                            hd: Css.margin2({
                                NAME: "px",
                                VAL: 10
                            }, {
                                NAME: "px",
                                VAL: 0
                            }),
                            tl: {
                                hd: Css.borderRadius({
                                    NAME: "px",
                                    VAL: 5
                                }),
                                tl: {
                                    hd: Css.cursor("pointer"),
                                    tl: {
                                        hd: Css.width({
                                            NAME: "px",
                                            VAL: 282
                                        }),
                                        tl: {
                                            hd: Css.selector("&:disabled", {
                                                hd: Css.opacity(0.5),
                                                tl: /* [] */ 0
                                            }),
                                            tl: /* [] */ 0
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var textInput = Curry._1(Css.style, {
    hd: Css.padding({
        NAME: "px",
        VAL: 20
    }),
    tl: {
        hd: Css.fontSize({
            NAME: "px",
            VAL: 17
        }),
        tl: {
            hd: Css.border({
                NAME: "px",
                VAL: 1
            }, "solid", {
                NAME: "hex",
                VAL: "ccc"
            }),
            tl: {
                hd: Css.width({
                    NAME: "px",
                    VAL: 240
                }),
                tl: {
                    hd: Css.margin2({
                        NAME: "px",
                        VAL: 10
                    }, {
                        NAME: "px",
                        VAL: 0
                    }),
                    tl: {
                        hd: Css.color({
                            NAME: "hex",
                            VAL: "494949"
                        }),
                        tl: {
                            hd: Css.borderRadius({
                                NAME: "px",
                                VAL: 5
                            }),
                            tl: {
                                hd: Css.selector("&::placeholder", {
                                    hd: Css.color({
                                        NAME: "hex",
                                        VAL: "ccc"
                                    }),
                                    tl: /* [] */ 0
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
exports.button = button;
exports.textInput = textInput; /* button Not a pure module */ 


/***/ }),

/***/ 2908:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var React = __webpack_require__(67294);
var Link = (__webpack_require__(41664)["default"]);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var styles = {
    marginRight: "10px"
};
function Header(Props) {
    var home = Props.home;
    var onClickCallToAction = Props.onClickCallToAction;
    return React.createElement("header", {
        className: Curry._1(Css.style, {
            hd: Css.width({
                NAME: "percent",
                VAL: 100
            }),
            tl: {
                hd: Css.display("flex"),
                tl: {
                    hd: Css.alignItems("center"),
                    tl: {
                        hd: Css.justifyContent("spaceBetween"),
                        tl: {
                            hd: Css.height(Css.px(100)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        })
    }, React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.flexDirection("row"),
                tl: {
                    hd: Css.justifyContent("spaceBetween"),
                    tl: {
                        hd: Css.width({
                            NAME: "percent",
                            VAL: 100
                        }),
                        tl: {
                            hd: Css.maxWidth(Css.px(1140)),
                            tl: {
                                hd: Css.marginLeft("auto"),
                                tl: {
                                    hd: Css.marginRight("auto"),
                                    tl: {
                                        hd: Css.alignItems("center"),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }, React.createElement("h1", {
        className: Curry._1(Css.style, {
            hd: Css.fontFamily({
                NAME: "custom",
                VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
            }),
            tl: {
                hd: Css.margin("zero"),
                tl: {
                    hd: Css.color({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, home ? React.createElement(React.Fragment, undefined, React.createElement("img", {
        className: Curry._1(Css.style, {
            hd: Css.width(Css.px(40)),
            tl: {
                hd: Css.verticalAlign("middle"),
                tl: {
                    hd: Css.marginRight({
                        NAME: "px",
                        VAL: 10
                    }),
                    tl: /* [] */ 0
                }
            }
        }),
        src: "/img/logo66.png"
    }), React.createElement("span", {
        className: Curry._1(Css.style, {
            hd: Css.fontSize(Css.px(30)),
            tl: {
                hd: Css.fontWeight({
                    NAME: "num",
                    VAL: 400
                }),
                tl: {
                    hd: Css.media("(max-width: 414px)", {
                        hd: Css.fontSize(Css.px(20)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, ReactUtils$SmartcutsMacros.s("smartcuts"))) : React.createElement(Link, {
        href: "/",
        children: React.createElement("a", {
            className: Curry._1(Css.style, {
                hd: Css.textDecoration("none"),
                tl: {
                    hd: Css.color({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: /* [] */ 0
                }
            })
        }, React.createElement("img", {
            className: Curry._1(Css.style, {
                hd: Css.verticalAlign("middle"),
                tl: {
                    hd: Css.marginRight({
                        NAME: "px",
                        VAL: 20
                    }),
                    tl: /* [] */ 0
                }
            }),
            src: "/img/logo66.png"
        }), React.createElement("span", undefined, ReactUtils$SmartcutsMacros.s("smartcuts")))
    })), React.createElement("nav", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.flexDirection("row"),
                tl: {
                    hd: Css.alignItems("center"),
                    tl: {
                        hd: Css.justifyContent("flexEnd"),
                        tl: {
                            hd: Css.flexGrow(1),
                            tl: {
                                hd: Css.flexShrink(1),
                                tl: {
                                    hd: Css.flexBasis({
                                        NAME: "percent",
                                        VAL: 1
                                    }),
                                    tl: {
                                        hd: Css.media("(max-width: 414px)", {
                                            hd: Css.display("none"),
                                            tl: /* [] */ 0
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }, React.createElement(Link, {
        href: "/login",
        children: React.createElement("a", {
            className: Curry._1(Css.style, {
                hd: Css.fontFamily({
                    NAME: "custom",
                    VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
                }),
                tl: {
                    hd: Css.color({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: {
                        hd: Css.textDecoration("none"),
                        tl: {
                            hd: Css.fontSize({
                                NAME: "px",
                                VAL: 20
                            }),
                            tl: {
                                hd: Css.marginRight(Css.px(24)),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            })
        }, ReactUtils$SmartcutsMacros.s("Login"))
    })), React.createElement("button", {
        className: Curry._1(Css.style, {
            hd: Css.backgroundColor({
                NAME: "hex",
                VAL: "fd6f2f"
            }),
            tl: {
                hd: Css.color({
                    NAME: "hex",
                    VAL: "fff"
                }),
                tl: {
                    hd: Css.borderRadius(Css.px(3)),
                    tl: {
                        hd: Css.padding2(Css.px(8), Css.px(20)),
                        tl: {
                            hd: Css.fontWeight({
                                NAME: "num",
                                VAL: 600
                            }),
                            tl: {
                                hd: Css.textTransform("uppercase"),
                                tl: {
                                    hd: Css.cursor("pointer"),
                                    tl: {
                                        hd: Css.borderStyle("none"),
                                        tl: {
                                            hd: Css.height(Css.px(40)),
                                            tl: {
                                                hd: Css.media("(max-width: 414px)", {
                                                    hd: Css.fontSize(Css.px(12)),
                                                    tl: /* [] */ 0
                                                }),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }),
        onClick: function(_event) {
            return Curry._1(onClickCallToAction, undefined);
        }
    }, ReactUtils$SmartcutsMacros.s("Request "), React.createElement("span", {
        className: Curry._1(Css.style, {
            hd: Css.media("(max-width: 414px)", {
                hd: Css.display("none"),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        })
    }, ReactUtils$SmartcutsMacros.s("Early ")), ReactUtils$SmartcutsMacros.s("Access"))));
}
var make = Header;
exports.styles = styles;
exports.make = make; /* Css Not a pure module */ 


/***/ }),

/***/ 64056:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var React = __webpack_require__(67294);
var Head = (__webpack_require__(9008)["default"]);
var Header$SmartcutsMacros = __webpack_require__(2908);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
function LayoutPublic(Props) {
    var homeOpt = Props.home;
    var onClickCallToAction = Props.onClickCallToAction;
    var children = Props.children;
    var home = homeOpt !== undefined ? homeOpt : false;
    return React.createElement(React.Fragment, undefined, React.createElement(Head, {
        children: null
    }, React.createElement("link", {
        href: "/favicon-16.png",
        rel: "icon",
        sizes: "16x16",
        type: "image/png"
    }), React.createElement("link", {
        href: "/favicon-32.png",
        rel: "icon",
        sizes: "32x32",
        type: "image/png"
    }), React.createElement("link", {
        href: "/favicon-96.png",
        rel: "icon",
        sizes: "96x96",
        type: "image/png"
    })), React.createElement(Header$SmartcutsMacros.make, {
        home: home,
        onClickCallToAction: onClickCallToAction
    }), React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.flexDirection("column"),
                tl: {
                    hd: Css.minHeight({
                        NAME: "vh",
                        VAL: 80.0
                    }),
                    tl: {
                        hd: Css.fontFamily({
                            NAME: "custom",
                            VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
                        }),
                        tl: {
                            hd: Css.alignItems("center"),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        })
    }, children), React.createElement("footer", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.alignItems("center"),
                tl: {
                    hd: Css.justifyContent("spaceAround"),
                    tl: {
                        hd: Css.flexWrap("wrap"),
                        tl: {
                            hd: Css.fontFamily({
                                NAME: "custom",
                                VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        })
    }, React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.color(Css.hex("acacae")),
            tl: {
                hd: Css.fontSize({
                    NAME: "px",
                    VAL: 12
                }),
                tl: {
                    hd: Css.selector("& > a", {
                        hd: Css.color(Css.hex("acacae")),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, ReactUtils$SmartcutsMacros.s("2021 \xa9 Smartcuts"), ReactUtils$SmartcutsMacros.s(" | "), React.createElement("a", {
        href: "/privacy_policy.html",
        target: "_blank"
    }, ReactUtils$SmartcutsMacros.s("Privacy policy")), ReactUtils$SmartcutsMacros.s(" | "), React.createElement("a", {
        href: "/terms_of_service.html",
        target: "_blank"
    }, ReactUtils$SmartcutsMacros.s("Terms of service")), ReactUtils$SmartcutsMacros.s(" | "), React.createElement("a", {
        href: "/cookie_policy.html",
        target: "_blank"
    }, ReactUtils$SmartcutsMacros.s("Cookie policy")))));
}
var make = LayoutPublic;
exports.make = make; /* Css Not a pure module */ 


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4951,9525,4797,1664,4795,310,2567,2349,2888,9774,179], function() { return __webpack_exec__(25436), __webpack_exec__(78883); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);